



































import { defineComponent, ref } from "@vue/composition-api";
import useCountDown from "@/hooks/useCountDown";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import PageTitle from "@/components/PageTitle";
import config from "./config";

export default defineComponent({
  name: "SixDigitConfirmView",
  components: { PageTitle, BaseButton, BaseInput },
  props: {
    email: { required: true, type: String },
    buttonText: { default: $t("Done"), type: String },
    loading: { type: Boolean },
  },
  setup(props, { emit }) {
    const code = ref<string>("");
    const { timeLeft, restart } = useCountDown(config.timeoutInSeconds);

    const codeResend = () => {
      emit("resend");
      restart();
    };
    return {
      code,
      timeLeft,
      codeResend,
    };
  },
});
